<template>
  <v-app>
    <ErrorAlert />
    <router-view />
    <div class="information-block" v-if="success">
      <v-alert text type="error" class="adblock-alert">
        <div class="d-flex">
          <div>
            AdBlock мешает корректной работе сайта. Выключите его для полного
            доступа ко всем функциям.
          </div>
          <v-icon @click="success = false" style="margin-left: 20px" color="var(--app-red-1)">
            mdi-close
          </v-icon>
        </div>
      </v-alert>
    </div>
  </v-app>
</template>
<script>
import ErrorAlert from "@/components/main/ErrorAlert";
import { detectAnyAdblocker } from "vue-adblock-detector";
export default {
  components: {
    ErrorAlert,
  },
  data: () => ({
    success: false,
  }),
  methods: {
    checkAdBlock() {
      detectAnyAdblocker().then((detected) => {
        if (detected) {
          this.success = true;
        } else {
          this.success = false;
        }
      });
    },
  },
  created() {
    this.checkAdBlock();
  },
};
</script>

<style>
.custom-hr {
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.vue-advanced-cropper__background,
.vue-advanced-cropper__foreground {
  background-color: #eeeeee !important;
  border: 1px solid #888888;
}

.vue-rectangle-stencil {
  border: 1px solid #888888 !important;
}
</style>
<style lang="scss">
html {
  overflow-y: auto;
}

* {
  font-family: "VTBGroup" !important;
}

.information-block {
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%);
  z-index: 10000;

  .adblock-alert {
    height: 80px;
    display: flex;
    align-items: center;
  }
}
</style>




